import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_ORDER_LISTING,
    ADD_ORDER,
    UPDATE_ORDER,
    DELETE_ORDER,
    EXPORT_ORDER,
    GET_ORDER_DETAILS,
    INSERT_LOG_ORDER,
    UPDATE_CUSTOMER_DETAILS,
    UPDATE_SHIPPING_DETAILS,
    UPDATE_BILLING_DETAILS,
    MARK_AS_PAID,
    MARK_AS_CLOSED,
    UPDATE_STATUS,
    UPDATE_COURIER,
    REVERT_ORDER_STATUS,
    DOWNLOAD_INVOICE,
} from "./actionTypes.js";

import {
    getOrderListingSuccess,
    getOrderListingFail,
    createOrderSuccess,
    createOrderFail,
    updateOrderSuccess,
    updateOrderFail,
    deleteOrderSuccess,
    deleteOrderFail,
    exportOrderSuccess,
    exportOrderFail,
    getOrderDetailsSuccess,
    getOrderDetailsFail,
    insertLogOrderSuccess,
    insertLogOrderFail,
    updateCustomerDetailsOrderSuccess,
    updateCustomerDetailsOrderFail,
    updateShippingDetailsOrderSuccess,
    updateShippingDetailsOrderFail,
    markAsPaidOrderSuccess,
    markAsPaidOrderFail,
    markAsClosedSuccess,
    markAsClosedFail,
    updateBillingDetailsOrderSuccess,
    updateBillingDetailsOrderFail,
    updateOrderStatusSuccess,
    updateOrderStatusFail,
    updateOrderCourierSuccess,
    updateOrderCourierFail,
    revertOrderStatusSuccess,
    revertOrderStatusFail,
    downloadInvoiceSuccess,
    downloadInvoiceFail,
} from "./actions.js";

import {
    orderListingApi,
    updateOrderApi,
    deleteOrderApi,
    exportOrderApi,
    orderDetailsApi,
    addOrderApi,
    insertOrderLogApi,
    updateCustomerDetailOrderApi,
    updateShippingDetailOrderApi,
    markAsPaidOrderApi,
    markAsClosedApi,
    updateBillingDetailOrderApi,
    updateOrderStatusApi,
    updateOrderCourierApi,
    revertOrderStatusApi,
    downloadInvoiceApi
} from "./orderApi.js";

function* fetchOrderListing({ payload }) {
    try {
        const response = yield call(orderListingApi, payload);
        yield put(getOrderListingSuccess(response));
    } catch (error) {
        yield put(getOrderListingFail(error));
    }
}

function* fetchOrderDetail({ payload }) {
    try {
        const response = yield call(orderDetailsApi, payload);
        yield put(getOrderDetailsSuccess(response));
    } catch (error) {
        yield put(getOrderDetailsFail(error));
    }
}

function* createOrder({ payload }) {
    try {
        const response = yield call(addOrderApi, payload);
        yield put(createOrderSuccess(response));
    } catch (error) {
        yield put(createOrderFail(error));
    }
}

function* updateOrder({ payload }) {
    try {
        const response = yield call(updateOrderApi, payload);
        yield put(updateOrderSuccess(response));
    } catch (error) {
        yield put(updateOrderFail(error));
    }
}

function* deleteOrder({ payload }) {
    try {
        const response = yield call(deleteOrderApi, payload);
        yield put(deleteOrderSuccess(response));
    } catch (error) {
        yield put(deleteOrderFail(error));
    }
}

function* insertLogOrder({ payload }) {
    try {
        const response = yield call(insertOrderLogApi, payload);
        yield put(insertLogOrderSuccess(response));
    } catch (error) {
        yield put(insertLogOrderFail(error));
    }
}

function* updateOrderCustomer({ payload }) {
    try {
        const response = yield call(updateCustomerDetailOrderApi, payload);
        yield put(updateCustomerDetailsOrderSuccess(response));
    } catch (error) {
        yield put(updateCustomerDetailsOrderFail(error));
    }
}

function* updateOrderShipping({ payload }) {
    try {
        const response = yield call(updateShippingDetailOrderApi, payload);
        yield put(updateShippingDetailsOrderSuccess(response));
    } catch (error) {
        yield put(updateShippingDetailsOrderFail(error));
    }
}

function* updateOrderBilling({ payload }) {
    try {
        const response = yield call(updateBillingDetailOrderApi, payload);
        yield put(updateBillingDetailsOrderSuccess(response));
    } catch (error) {
        yield put(updateBillingDetailsOrderFail(error));
    }
}

function* markAsPaidOrder({ payload }) {
    try {
        const response = yield call(markAsPaidOrderApi, payload);
        yield put(markAsPaidOrderSuccess(response));
    } catch (error) {
        yield put(markAsPaidOrderFail(error));
    }
}

function* markAsClosed({ payload }) {
    try {
        const response = yield call(markAsClosedApi, payload);
        yield put(markAsClosedSuccess(response));
    } catch (error) {
        yield put(markAsClosedFail(error));
    }
}

function* updateOrderStatus({ payload }) {
    try {
        const response = yield call(updateOrderStatusApi, payload);
        yield put(updateOrderStatusSuccess(response));
    } catch (error) {
        yield put(updateOrderStatusFail(error));
    }
}

function* updateOrderCourier({ payload }) {
    try {
        const response = yield call(updateOrderCourierApi, payload);
        yield put(updateOrderCourierSuccess(response));
    } catch (error) {
        yield put(updateOrderCourierFail(error));
    }
}

function* revertOrderStatus({ payload }) {
    try {
        const response = yield call(revertOrderStatusApi, payload);
        yield put(revertOrderStatusSuccess(response));
    } catch (error) {
        yield put(revertOrderStatusFail(error));
    }
}

function* downloadInvoiceOrder({ payload }) {
    try {
        const response = yield call(downloadInvoiceApi, payload);
        yield put(downloadInvoiceSuccess(response));
    } catch (error) {
        yield put(downloadInvoiceFail(error));
    }
}

function* exportOrder({ payload }) {
    try {
        const response = yield call(exportOrderApi, payload);
        yield put(exportOrderSuccess(response));
    } catch (error) {
        yield put(exportOrderFail(error));
    }
}

function* OrderSaga() {
    yield takeEvery(GET_ORDER_LISTING, fetchOrderListing);
    yield takeEvery(GET_ORDER_DETAILS, fetchOrderDetail);
    yield takeEvery(ADD_ORDER, createOrder);
    yield takeEvery(UPDATE_ORDER, updateOrder);
    yield takeEvery(DELETE_ORDER, deleteOrder);
    yield takeEvery(INSERT_LOG_ORDER, insertLogOrder);
    yield takeEvery(UPDATE_CUSTOMER_DETAILS, updateOrderCustomer);
    yield takeEvery(UPDATE_SHIPPING_DETAILS, updateOrderShipping);
    yield takeEvery(UPDATE_BILLING_DETAILS, updateOrderBilling);
    yield takeEvery(MARK_AS_PAID, markAsPaidOrder);
    yield takeEvery(MARK_AS_CLOSED, markAsClosed);
    yield takeEvery(UPDATE_STATUS, updateOrderStatus);
    yield takeEvery(UPDATE_COURIER, updateOrderCourier);
    yield takeEvery(REVERT_ORDER_STATUS, revertOrderStatus);
    yield takeEvery(DOWNLOAD_INVOICE, downloadInvoiceOrder);
    yield takeEvery(EXPORT_ORDER, exportOrder);

}

export default OrderSaga
